import { AnimatePresence, motion } from "motion/react";
import { CalendarDays, Camera, CheckSquare2, Gauge, Gift, House, LogOut, Luggage, Menu, MessageSquareText, MoonStar, ScrollText, ShoppingBasket, X } from "lucide-react";
import { useState } from "react";
import { Navigate, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getDashboard } from "../lib/api";
import { PixelMark } from "./PixelMark";

const nav = [
  { to: "/", label: "World hub", icon: House },
  { to: "/world/tasks", label: "Quests", icon: CheckSquare2 },
  { to: "/world/trips", label: "Routes", icon: Luggage },
  { to: "/world/shopping", label: "Supplies", icon: ShoppingBasket },
  { to: "/world/photos", label: "Photo dump", icon: Camera },
  { to: "/world/notes", label: "Signals", icon: MessageSquareText },
  { to: "/world/dreams", label: "Dream map", icon: MoonStar },
  { to: "/world/wishlist", label: "Wishlist", icon: Gift },
  { to: "/world/dates", label: "Dates", icon: CalendarDays },
  { to: "/world/memories", label: "Archive", icon: ScrollText },
];

export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { data, isLoading, isError } = useQuery({ queryKey: ["dashboard"], queryFn: getDashboard, retry: false });
  if (isLoading) return <div className="page-loading"><i /><span>Synchronizing world state</span></div>;
  if (isError || !data) return <Navigate to="/login" replace />;
  return <div className="app-shell">
    <div className="atmosphere" aria-hidden="true"><i /><i /><i /><i /><i /><i /></div>
    <aside className={open ? "side-rail open" : "side-rail"}>
      <div className="rail-top"><PixelMark /><button className="icon-button mobile-close" onClick={() => setOpen(false)} aria-label="Close navigation"><X /></button></div>
      <nav aria-label="World navigation">
        {nav.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)}><Icon /><span>{label}</span><b /></NavLink>)}
      </nav>
      {data.user.role === "admin" && <NavLink className="admin-link" to="/admin"><Gauge /><span>Core control</span><em>ADMIN</em></NavLink>}
      <div className="rail-status"><span className="online-dot" /><div><strong>WORLD ONLINE</strong><small>encrypted signal</small></div><button className="signout" title="Leave world" onClick={async()=>{await fetch("/api/auth/sign-out",{method:"POST",credentials:"include"});navigate("/login")}}><LogOut/></button></div>
    </aside>
    <main className="main-stage">
      <header className="mobile-header"><button className="icon-button" onClick={() => setOpen(true)} aria-label="Open navigation"><Menu /></button><PixelMark compact /><span className="online-dot" /></header>
      <AnimatePresence mode="wait"><motion.div key={location.pathname} className="route-frame" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: .24, ease: [0.2, 0.8, 0.2, 1] }}><Outlet /></motion.div></AnimatePresence>
    </main>
  </div>;
}
